<template>
  <div class="dict-config-page">
    <div class="page-header">
      <div class="header-left">
        <h2>字典配置</h2>
        <p class="header-desc">
          管理系统基础数据字典，用于线路分类、标签等模块。
        </p>
      </div>
    </div>
    <div class="config-container">
      <div class="left-panel">
        <div class="panel-header">
          <span class="panel-title">字典类型</span>
        </div>
        <el-table
          :data="typeList"
          style="width: 100%"
          v-loading="typeLoading"
          :row-key="(row) => row.dictType"
          @row-click="handleTypeClick"
          :highlight-current-row="true"
          :current-row-key="selectedType ? selectedType.dictType : null"
        >
          <el-table-column label="类型名称" min-width="150">
            <template slot-scope="scope">
              <div class="type-name">
                <span>{{ scope.row.dictName }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="类型编码" width="150">
            <template slot-scope="scope">
              <span class="type-code">{{ scope.row.dictType }}</span>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <span class="pagination-info">共 {{ typeTotal }} 条记录</span>
          <el-pagination
            @size-change="handleTypeSizeChange"
            @current-change="handleTypeCurrentChange"
            :current-page="typeCurrentPage"
            :page-sizes="[10, 20, 50]"
            :page-size="typePageSize"
            layout="sizes, prev, pager, next, jumper"
            :total="typeTotal"
          >
          </el-pagination>
        </div>
      </div>

      <div class="right-panel">
        <div class="panel-header">
          <span class="panel-title">{{
            selectedType
              ? selectedType.dictName + ' (' + selectedType.dictType + ')'
              : '请选择字典类型'
          }}</span>
          <div class="header-actions">
            <!-- <el-input
              v-model="keyword"
              placeholder="搜索项名称..."
              class="search-input"
              @keyup.enter="handleSearch"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="handleSearch"
              ></el-button>
            </el-input> -->
            <el-button v-if="selectedType" type="primary" @click="handleCreate">
              <i class="el-icon-plus"></i> 新增字典项
            </el-button>
          </div>
        </div>
        <el-table
          v-if="selectedType"
          :data="dataList"
          style="width: 100%"
          v-loading="dataLoading"
          border
        >
          <el-table-column label="显示值" min-width="150">
            <template slot-scope="scope">
              {{ scope.row.dictLabel }}
            </template>
          </el-table-column>
          <el-table-column label="编码值" min-width="150">
            <template slot-scope="scope">
              {{ scope.row.dictValue }}
            </template>
          </el-table-column>
          <el-table-column label="排序号" width="100">
            <template slot-scope="scope">
              {{ scope.row.dictSort || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="70">
            <template slot-scope="scope">
              <el-tag
                :type="
                  scope.row.status === '0' || scope.row.status === 0
                    ? 'success'
                    : 'danger'
                "
              >
                {{
                  scope.row.status === '0' || scope.row.status === 0
                    ? '启用'
                    : '禁用'
                }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="handleView(scope.row)">
                查看
              </el-button>
              <el-button
                v-if="scope.row.status === '1' || scope.row.status === 1"
                type="text"
                @click="editData(scope.row)"
              >
                编辑
              </el-button>
              <!-- <el-button
                v-if="scope.row.status === '1' || scope.row.status === 1"
               
                type="text"
                @click="handleDelete(scope.row)"
              >
                删除
              </el-button> -->
              <el-button
                v-if="scope.row.status === '1' || scope.row.status === 1"
                type="text"
                @click="handleToggleStatus(scope.row, 0)"
              >
                启用
              </el-button>
              <el-button
                v-else
                type="text"
                @click="handleToggleStatus(scope.row, 1)"
              >
                禁用
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-else class="empty-tip">
          <i class="el-icon-document"></i>
          <p>请选择左侧字典类型</p>
        </div>
        <div v-if="selectedType" class="pagination">
          <span class="pagination-info"
            >显示第 {{ (dataCurrentPage - 1) * dataPageSize + 1 }} 至
            {{ Math.min(dataCurrentPage * dataPageSize, dataTotal) }} 条，共
            {{ dataTotal }} 条记录</span
          >
          <el-pagination
            @size-change="handleDataSizeChange"
            @current-change="handleDataCurrentChange"
            :current-page="dataCurrentPage"
            :page-sizes="[10, 20, 50]"
            :page-size="dataPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="dataTotal"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- 字典项弹窗 -->
    <el-dialog
      :title="
        isViewMode ? '查看字典项' : currentData ? '编辑字典项' : '新增字典项'
      "
      :visible.sync="dialogVisible"
      width="450px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="formRef"
        :model="formData"
        :rules="formRules"
        label-width="100px"
      >
        <el-form-item label="显示值" prop="dictLabel">
          <el-input
            v-model="formData.dictLabel"
            :disabled="isViewMode"
            placeholder="如：休闲"
          />
        </el-form-item>
        <el-form-item label="编码值" prop="dictValue">
          <el-input
            v-model="formData.dictValue"
            :disabled="isViewMode || currentData !== null"
            placeholder="如：leisure"
          />
        </el-form-item>
        <el-form-item label="排序号" prop="dictSort">
          <el-input-number
            v-model="formData.dictSort"
            :disabled="isViewMode"
            :min="0"
            :max="99999"
            placeholder="请输入排序号"
            style="width: 100%"
          />
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="formData.status" :disabled="isViewMode">
            <el-radio label="0">启用</el-radio>
            <el-radio label="1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button
          v-if="!isViewMode"
          type="primary"
          @click="confirmSave"
          :loading="saveLoading"
          >确认保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'DictConfig',
  data() {
    return {
      // 类型列表
      typeList: [],
      typeLoading: false,
      typeCurrentPage: 1,
      typePageSize: 20,
      typeTotal: 0,
      // 选中类型
      selectedType: null,
      // 字典项列表
      dataList: [],
      dataLoading: false,
      dataCurrentPage: 1,
      dataPageSize: 20,
      dataTotal: 0,
      keyword: '',
      // 弹窗
      dialogVisible: false,
      formData: {
        dictType: '',
        dictLabel: '',
        dictValue: '',
        dictSort: '',
        status: '1'
      },
      formRules: {
        dictLabel: [
          { required: true, message: '请输入显示值', trigger: 'blur' }
        ],
        dictValue: [
          { required: true, message: '请输入编码值', trigger: 'blur' },
          {
            validator: this.validateDictValue,
            trigger: 'blur'
          }
        ],
        dictSort: [
          {
            type: 'number',
            min: 0,
            message: '排序号必须为正整数',
            trigger: 'blur'
          }
        ],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      },
      saveLoading: false,
      currentData: null,
      isViewMode: false
    }
  },
  mounted() {
    this.fetchTypeList()
  },
  methods: {
    // 验证编码值格式
    validateDictValue(rule, value, callback) {
      if (!value) {
        callback()
        return
      }
      // 正则：必须以字母开头，只能包含字母和数字
      const regex = /^[a-zA-Z][a-zA-Z0-9]*$/
      if (!regex.test(value)) {
        callback(new Error('编码值必须以字母开头，只能包含大小写字母和数字'))
      } else {
        callback()
      }
    },
    // 获取类型列表
    async fetchTypeList() {
      this.typeLoading = true
      try {
        const res = await this.$http.post('dict/getDictTypeList.do', {
          pageNum: this.typeCurrentPage,
          pageSize: this.typePageSize
        })
        if (res.code === '0' || res.code === 0) {
          this.typeList = res.result || []
          this.typeTotal = res.total || 0
          // 默认选中 route_theme
          const defaultType = this.typeList.find(
            (item) => item.dictType === 'route_type'
          )
          if (defaultType) {
            this.selectedType = defaultType
            this.dataCurrentPage = 1
            this.fetchDataList()
          }
        } else {
          this.$message.error(res.message || '获取类型列表失败')
        }
      } catch (error) {
        console.error('获取类型列表错误:', error)
        this.$message.error('网络请求异常')
      } finally {
        this.typeLoading = false
      }
    },
    // 获取字典项列表
    async fetchDataList() {
      if (!this.selectedType) return
      this.dataLoading = true
      try {
        const res = await this.$http.post('dict/getDictDataList.do', {
          dictType: this.selectedType.dictType,
          pageNum: this.dataCurrentPage,
          pageSize: this.dataPageSize
        })
        if (res.code === '0' || res.code === 0) {
          this.dataList = res.result || []
          this.dataTotal = res.total || 0
        } else {
          this.$message.error(res.message || '获取字典项列表失败')
        }
      } catch (error) {
        console.error('获取字典项列表错误:', error)
        this.$message.error('网络请求异常')
      } finally {
        this.dataLoading = false
      }
    },
    // 点击类型
    handleTypeClick(row) {
      this.selectedType = row
      this.dataCurrentPage = 1
      this.fetchDataList()
    },
    // 搜索
    handleSearch() {
      this.dataCurrentPage = 1
      this.fetchDataList()
    },
    // 新增
    handleCreate() {
      this.isViewMode = false
      this.currentData = null
      this.formData = {
        dictType: this.selectedType.dictType,
        dictLabel: '',
        dictValue: '',
        dictSort: '',
        status: '1'
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    // 查看详情
    handleView(row) {
      this.isViewMode = true
      this.currentData = row
      this.formData = {
        dictType: row.dictType,
        dictLabel: row.dictLabel,
        dictValue: row.dictValue,
        dictSort: row.dictSort || '',
        status: String(row.status)
      }
      this.dialogVisible = true
    },
    // 编辑
    editData(row) {
      this.isViewMode = false
      this.currentData = row
      this.formData = {
        dictType: row.dictType,
        dictLabel: row.dictLabel,
        dictValue: row.dictValue,
        dictSort: row.dictSort || '',
        status: String(row.status)
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.formRef && this.$refs.formRef.clearValidate()
      })
    },
    // 删除
    handleDelete(row) {
      if (!(row.status === '0' || row.status === 0)) {
        this.$message.warning('启用状态下不能删除')
        return
      }
      this.$confirm('确定要删除该字典项吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          try {
            const res = await this.$http.post('dict/deleteDictData.do', {
              dictCode: row.dictCode
            })
            if (res.code === '0' || res.code === 0) {
              this.$message.success('删除成功')
              this.fetchDataList()
            } else {
              this.$message.error(res.message || '删除失败')
            }
          } catch (error) {
            console.error('删除错误:', error)
            this.$message.error('网络请求异常')
          }
        })
        .catch(() => {
          this.$message.info('已取消删除')
        })
    },
    // 切换状态
    handleToggleStatus(row, status) {
      const action = status === 1 ? '启用' : '禁用'
      this.$confirm(`确定要${action}该字典项吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: status === 1 ? 'success' : 'warning'
      })
        .then(async () => {
          try {
            const res = await this.$http.get(
              `dict/updateDictDataStatus.do?dictCode=${row.dictCode}&status=${status}`
            )
            if (res.code === '0' || res.code === 0) {
              this.$message.success(`${action}成功`)
              this.fetchDataList()
            } else {
              this.$message.error(res.message || `${action}失败`)
            }
          } catch (error) {
            console.error(`${action}错误:`, error)
            this.$message.error('网络请求异常')
          }
        })
        .catch(() => {
          this.$message.info(`已取消${action}`)
        })
    },
    // 保存
    async confirmSave() {
      try {
        await this.$refs.formRef.validate()

        this.saveLoading = true
        const url = this.currentData
          ? 'dict/updateDictData.do'
          : 'dict/addDictData.do'
        const params = { ...this.formData }
        if (this.currentData) {
          params.dictCode = this.currentData.dictCode
        }

        const res = await this.$http.post(url, params)
        if (res.code === '0' || res.code === 0) {
          this.$message.success(this.currentData ? '修改成功' : '新增成功')
          this.dialogVisible = false
          this.fetchDataList()
        } else {
          this.$message.error(res.message || '保存失败')
        }
      } catch (error) {
        if (error !== 'cancel') {
          console.error('保存错误:', error)
          this.$message.error(error.message || '网络请求异常')
        }
      } finally {
        this.saveLoading = false
      }
    },
    // 类型分页
    handleTypeSizeChange(val) {
      this.typePageSize = val
      this.typeCurrentPage = 1
      this.fetchTypeList()
    },
    handleTypeCurrentChange(val) {
      this.typeCurrentPage = val
      this.fetchTypeList()
    },
    // 字典项分页
    handleDataSizeChange(val) {
      this.dataPageSize = val
      this.dataCurrentPage = 1
      this.fetchDataList()
    },
    handleDataCurrentChange(val) {
      this.dataCurrentPage = val
      this.fetchDataList()
    }
  }
}
</script>

<style scoped>
.dict-config-page {
  padding: 20px 24px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 80px);
}

.page-header {
  margin-bottom: 20px;
}

.header-left h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #1f2937;
}

.header-desc {
  margin: 4px 0 0 0;
  font-size: 13px;
  color: #6b7280;
}

.config-container {
  display: flex;
  gap: 20px;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  padding: 20px;
}

.left-panel {
  width: 500px;
  flex-shrink: 0;
  border-right: 1px solid #f0f0f0;
  padding-right: 20px;
}

.left-panel .el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgba(34, 197, 94, 0.05);
}

.left-panel .el-table__body tr.current-row > td {
  background-color: rgba(34, 197, 94, 0.15);
}

.right-panel {
  flex: 1;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.panel-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 12px;
}

.search-input {
  width: 280px;
}

.type-name {
  font-size: 14px;
  color: #1f2937;
}

.type-code {
  font-size: 12px;
  color: #9ca3af;
  font-family: monospace;
}

.empty-tip {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #9ca3af;
}

.empty-tip i {
  font-size: 48px;
  margin-bottom: 16px;
}

.empty-tip p {
  margin: 0;
  font-size: 14px;
}

.pagination {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 0;
  border-top: 1px solid #f0f0f0;
  margin-top: 10px;
}

.pagination-info {
  font-size: 13px;
  color: #6b7280;
}

.pagination .el-pagination {
  margin: 0;
}

.pagination .el-pagination button {
  border-radius: 6px;
}

.pagination .el-pagination .el-pager li.active {
  background-color: #22c55e;
  border-color: #22c55e;
  color: #fff;
}

.pagination .el-pagination .el-pager li.active:hover {
  background-color: #16a34a;
}
</style>
